import React from "react";
import '../CSS/clips.css';
function Clips () {
    return(
        <div>
            <h2 className="title">Coming soon...</h2>
        </div>
    )
}
export default Clips;